import React, { useEffect } from "react";
import { history } from "../Redux/Index";
import { resolveLandingRoute, usePermissions } from "./PermissionsContext";

/**
 * Corrige l'atterrissage post-login UNE FOIS les permissions chargées : Login/redirectCallback
 * s'exécutent avant et renvoient toujours /dashboard par défaut. Pour un rôle mono-métier
 * (macroéconomie), la page de travail remplace le dashboard. Les deep-links restaurés par
 * appState.returnTo ne passent pas par « / » ni « /dashboard » et ne sont donc jamais touchés.
 * Utilise le singleton history de l'app (celui de ConnectedRouter) plutôt que les hooks
 * react-router, qui ne sont pas fiables dans cette version du routeur.
 */
export const LandingRedirect: React.FC = () => {
	const { ready, permissions } = usePermissions();

	useEffect(() => {
		if (!ready) return;
		const pathname = history.location.pathname;
		if (pathname !== "/" && pathname !== "/dashboard") return;
		const landing = resolveLandingRoute(permissions);
		if (landing !== pathname) {
			history.replace(landing);
		}
	}, [ready, permissions]);

	return null;
};
